import * as api from '../complianceSalesApi';
import {
  call,
  put,
  select,
  takeEvery
  } from 'redux-saga/effects';
import {
  ComplianceSalesActionKeys,
  FetchSalesCompliance,
  ISalesComplianceResponse,
  salesComplianceActionCreators
  } from '..';
import {
  FilterTypes,
  getFilteredSalesDistricts,
  getFilters,
  ISalesComplianceFilters
  } from '../../filters';
import { IState } from '../..';

function* fetchSalesComplianceSaga(action: FetchSalesCompliance) {
  yield put(salesComplianceActionCreators.toggleLoading());

  let filters: ISalesComplianceFilters = yield select((state: IState) =>
    getFilters(state, FilterTypes.salesCompliance)
  );

  const salesDistricts: string[] = yield select((state: IState) => getFilteredSalesDistricts(state, filters));
  filters = { ...filters, salesDistricts };
  try {
    const response: ISalesComplianceResponse = yield call(api.FetchSalesCompliance, filters);

    if (response) {
      yield put(salesComplianceActionCreators.set(response));
    }
  } catch {
    //
  }
  yield put(salesComplianceActionCreators.toggleLoading());
}

export function* watchFetchSalesCompliance() {
  yield takeEvery(ComplianceSalesActionKeys.FETCH_SALES_COMPLIANCE, fetchSalesComplianceSaga);
}
